// extracted by mini-css-extract-plugin
export default {"wrapper":"USO4ImhBiil5nUVSsTIh"};